import { useEffect, useState, useMemo } from "react";
import { useAppSelector } from "../redux-store/CustomReduxHooks";
import { PathKey, pathToLobCodeMap } from "../utils/constants";
import {
  getIsChannelValid,
  getIsExactLobValid,
  getIsPlatformValid,
  usePlatformFlags,
  useUserLobInfo,
} from "./utils/bannerFilterUtils";
import { T_NudgeBannerData } from "../features/Features_Cms/CmsGlobal.Types";
import { useLocation } from "react-router-dom";

const useSuccessNudgeData = () => {
  const { cmsNudgeBannerData } = useAppSelector((state) => state?.CmsSlice);
  const userDetails = useAppSelector((state) => state.CsAppSlice.userDetails);
  const platform = useAppSelector((state) => state.CsAppSlice.platform);
  const csAppSlice = useAppSelector((state) => state.CsAppSlice);
  const [nudgeData, setNudgeData] = useState<any[]>([]);
  const location = useLocation();

  // Memoize platform detection
  const platformFlags = usePlatformFlags(
    csAppSlice.channel,
    csAppSlice.NativeDeviceInfo?.deviceName,
  );

  const { lobCodes, channels } = useUserLobInfo(
    userDetails?.customerAndLobDetails,
    userDetails?.IS_NTB_USER,
    userDetails?.IS_USER_REGISTERED,
  );

  // Memoize path info
  const pathInfo = useMemo(() => {
    const currentPath = location.pathname;
    const matchedBasePath = Object.keys(pathToLobCodeMap).find((key) =>
      currentPath.startsWith(key),
    );
    const expectedLobCode = matchedBasePath
      ? pathToLobCodeMap[matchedBasePath as PathKey]
      : undefined;
    return { currentPath, expectedLobCode };
  }, [location.pathname]);

  useEffect(() => {
    const filteredLobCodes = pathInfo.expectedLobCode
      ? lobCodes.filter((code) => code === pathInfo.expectedLobCode)
      : [];

    let filteredData: T_NudgeBannerData[] = [];

    filteredData = cmsNudgeBannerData.filter((i) => {
      // LOB validation
      let isLobIdValid = getIsExactLobValid(
        i.attributes?.lobCohorts || "",
        filteredLobCodes,
      );
      if (!isLobIdValid) return false;

      // Channel validation using shared utility
      const isChannelValid = getIsChannelValid(
        i.attributes?.channel || "",
        channels,
      );
      if (!isChannelValid) return false;

      // Platform validation using shared utility
      const isPlatformValid = getIsPlatformValid(
        i.attributes.platform || "",
        platformFlags,
      );

      return isPlatformValid;
    });
    setNudgeData(filteredData);
  }, [
    platform,
    cmsNudgeBannerData,
    userDetails,
    lobCodes,
    channels,
    pathInfo,
    platformFlags,
  ]);

  return nudgeData.length > 0 ? nudgeData[0] : null;
};

export default useSuccessNudgeData;
